import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type Banner = {
  campaign_id: string;
  template: string;
  title: string;
  subtitle: string;
  description: string;
  start_date: string;
  end_date: string;
  url: string;
  slug?: string | null;
  image: string;
  priority: string;
  image_url: string;
  content?: string;
  content_color?: string;
  line1?: string;
  line1_color?: string;
  button_text?: string;
  button_color?: string;
  template_description?: string;
  template_description_color?: string;
};

interface State {
  banners: Banner[] | null;
  isLoading: boolean | null;
  totalItems: number;
  currentPage: number;
}

export const initialState: State = {
  banners: null,
  isLoading: false,
  totalItems: 0,
  currentPage: 1,
};

const bannersSlice = createSlice({
  name: 'banners',
  initialState,
  reducers: {
    setBanners(state, { payload }: PayloadAction<Banner[] | null>) {
      state.banners = payload;
    },
    setTotalItems(state, { payload }: PayloadAction<number>) {
      state.totalItems = payload;
    },
    setCurrentPage(state, { payload }: PayloadAction<number>) {
      state.currentPage = payload;
    },
  },
});

export const { setBanners, setTotalItems, setCurrentPage } =
  bannersSlice.actions;

export default bannersSlice.reducer;
